import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from "@fluentui/react-components";
const STATUS_LABELS = {
    // DB snake_case → label FR
    en_attente: "En attente", en_attente_n1: "En attente N+1",
    en_attente_n2: "En attente N+2", en_attente_rh: "En attente RH",
    approuve: "Approuvé", refuse: "Refusé", annule: "Annulé",
    brouillon: "Brouillon", soumis: "Soumis", valide: "Validé", rejete: "Rejeté",
    en_cours: "En cours", traite: "Traité", erreur: "Erreur",
};
const STATUS_COLORS = {
    "En attente": "warning", "En attente N+1": "warning",
    "En attente N+2": "warning", "En attente RH": "warning",
    "Approuve": "success", "Approuvé": "success", "Approuvée": "success",
    "Refuse": "danger", "Refusé": "danger", "Refusée": "danger",
    "Annule": "informative", "Annulé": "informative", "Annulée": "informative",
    "Nouveau": "warning", "En cours": "informative",
    "Resolu": "success", "Résolu": "success", "Ferme": "informative",
    "Brouillon": "informative", "Soumis": "warning",
    "Valide": "success", "Validé": "success",
    "Rejete": "danger", "Rejeté": "danger",
    "Traité": "success", "Traitée": "success", "Erreur": "danger",
};
export const StatusBadge = ({ status }) => {
    const label = STATUS_LABELS[status] || status;
    return (_jsx(Badge, { color: STATUS_COLORS[label] || STATUS_COLORS[status] || "informative", appearance: "filled", children: label }));
};
